import type { SlideProps } from "@/engine/app/offsite-config";

interface Statement {
  title: string;
  body: string;
}

/** Drei Aussagen tragen die Einführung. Mehr braucht es nicht. */
const STATEMENTS: Statement[] = [
  {
    title: "Sie beschreiben",
    body: "Kein Formular, keine Fachsprache. Sie schreiben in eigenen Worten auf, woran Sie arbeiten wollen und worauf es Ihnen dabei ankommt.",
  },
  {
    title: "Die KI baut",
    body: "Aus Ihrer Beschreibung entsteht eine lauffähige Anwendung. Das dauert wenige Minuten — in dieser Zeit zeigen wir Ihnen das SVO OS.",
  },
  {
    title: "Sie sehen das Ergebnis",
    body: "Am Ende der Sitzung liegt für jeden von Ihnen ein Prototyp vor. Nicht als Konzept auf Papier, sondern als etwas, das man anklicken kann.",
  },
];

export function Slide02Einfuehrung(_: SlideProps) {
  return (
    <div className="deck-root ar-slide" style={{ background: "var(--ink-900)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1" style={{ color: "var(--ink-400)" }}>
          Worum es geht
        </div>
        <h1 className="deck-title rise rise-2">Drei Schritte</h1>
      </header>

      <div className="ar-statements">
        {STATEMENTS.map((s, i) => (
          <section key={s.title} className={`ar-statement rise rise-${i + 3}`}>
            <h2 className="ar-statement-title">{s.title}</h2>
            <p className="ar-statement-body">{s.body}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
